const ROOT = 'RATE_CARD_CREATE_';

const actions = {
  UPLOAD_SIDE_REQUEST: `${ROOT}UPLOAD_SIDE_REQUEST`,
  UPLOAD_SIDE_SUCCESS: `${ROOT}UPLOAD_SIDE_SUCCESS`,
  UPLOAD_SIDE_ERROR: `${ROOT}UPLOAD_SIDE_ERROR`,
  CLEAR_SIDE: `${ROOT}CLEAR_SIDE`,

  DOWNLOAD_TEMPLATE_REQUEST: `${ROOT}DOWNLOAD_TEMPLATE_REQUEST`,
  DOWNLOAD_TEMPLATE_SETTLED: `${ROOT}DOWNLOAD_TEMPLATE_SETTLED`,

  CREATE_REQUEST: `${ROOT}CREATE_REQUEST`,
  CREATE_SUCCESS: `${ROOT}CREATE_SUCCESS`,
  CREATE_ERROR: `${ROOT}CREATE_ERROR`,

  CLEAR_STORE: `${ROOT}CLEAR_STORE`,
} as const;

export default actions;
